<template>
    <div>
        <md-table v-model="users.content" v-if="!loading">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell :md-label="$t('views.admin.dashboard.ad.table.label.user-name')">{{ item.userName }}</md-table-cell>
                <md-table-cell :md-label="$t('views.admin.dashboard.ad.table.label.first-name')">{{ item.firstName }}</md-table-cell>
                <md-table-cell :md-label="$t('views.admin.dashboard.ad.table.label.last-name')">{{ item.lastName }}</md-table-cell>
                <md-table-cell :md-label="$t('views.admin.dashboard.ad.table.label.email')">{{ item.email }}</md-table-cell>
                <md-table-cell :md-label="$t('views.admin.dashboard.ad.table.label.actions')">
                    <md-button v-if="hasAccess('PRIVILEGE_AD_USERS_ACTIVATION') && item.needActivate" class="md-icon-button" @click="activateUser(item.keycloak_id)">
                        <md-icon>add</md-icon>
                        <md-tooltip md-direction="top">{{ $t('activate') }}</md-tooltip>
                    </md-button>
                </md-table-cell>
            </md-table-row>
            <md-table-empty-state
                v-if="!loading"
                class="md-layout-item md-size-100"
                :md-label="$t('dialog.noData')" />
        </md-table>
        <Spiner :loading="loading" />
        <div class="md-layout">
            <paginator :page.sync="currentPage" :show-page-numbers="false"
                        :length="users.totalElements || 0" :page-size.sync="pageSize"
                        @pageChange="closeSearch(), loadUsers(currentPage - 1 , pageSize)" />
        </div>
    </div>
</template>

<script>
    import {usersEndpoint, adminsEndpoint} from '@/services/adsign-backend/endpoints';
    import Paginator from '@/components/Paginator';
    import utils from '@/mixins/utils';
    import serverSideValidationErrors from '@/mixins/serverSideValidationErrors';
    import { mapGetters, mapActions } from "vuex";
    import sortSupport from "@/mixins/sortSupport";
    import Spiner from '@/components/Spiner';
    import store from '@/store'

    export default {
        name: 'ADUserList',
        mixins: [utils, serverSideValidationErrors, sortSupport],
        components: {Paginator, Spiner},
        computed: {
            ...mapGetters('auth', ['hasAccess'])
        },
        props: {
            filterValue: {
                type: [Number,String],
                default: 1
            }
        },
        data: () => ({
            currentPage: 1,
            users: {
                content: [],
                pageable: {
                    pageSize: 0
                },
                totalElements: null,
                totalPages: null
            },
            loading: false
        }),
        mounted() {
            this.setTabsNavObj({
                routeForButton: '',
                translationParameter: '',
                alternateCallback: this.synchronizeAdUsers,
                alternateTranslationPath: 'views.admin.dashboard.ad.button.synchronize',
            });
            this.loadUsers();
            this.$watch(() => this.filterValue, (result) => {
                this.currentPage = Number(result)
                this.loadUsers(result - 1, this.pageSize);
            })
            this.$watch(() => this.currentPage, (result) => {
                if(isNaN(Number(result))){
                    store.commit('snackbar/SNACKBAR_TITLE', 'Musisz podać numer strony')
                    store.commit('snackbar/SNACKBAR_SHOW', true)
                    this.currentPage = 1
                }
                if(!result){
                    this.currentPage = 1
                }
            })
        },

        methods: {
            loadUsers(page, pageSize=10) {
                this.loading = true
                usersEndpoint.getADUsers(page, pageSize)
                    .then((response) => {
                        this.users = response.data;
                    })
                    .catch(this.handleServerValidationError)
                    .finally(() => this.loading = false)
            },
            activateUser(keycloakId) {
                adminsEndpoint.activateUserAD({ 'keycloakId': keycloakId })
                    .then((response) => this.loadUsers(this.currentPage - 1 , this.pageSize) )
                    .catch(this.handleServerValidationError);
            },
            synchronizeAdUsers() {
                adminsEndpoint.synchronizeAdUsers()
                    .then(() => this.loadUsers(this.currentPage, this.pageSize))
                    .catch(this.handleServerValidationError);
            },
            ...mapActions('misc', ['setTabsNavObj']),
            closeSearch(){
                this.$emit('closeSearcher', false)
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
